import { useState } from "react"
import styled from "styled-components"

import withHoverable from "./withHoverable"

const SContainer = styled.figure`
  margin: 0;
  padding: 0;
  position: relative;
  max-width: 100%;
`
const SBackgroundSquare = styled.img`
  background-color: grey;
  max-width: 100%;
  position: absolute;
  transition: all 0.3s;

  &:last-child {
    position: relative;
  }
`
const example = [
  "https://tympanus.net/Development/StackEffects/img/1.png",
  "https://tympanus.net/Development/StackEffects/img/2.png",
  "https://tympanus.net/Development/StackEffects/img/3.png",
]

const ImageStack = ({
  images = example,
  isHovered,
  isClickable,
}: {
  images: string[]
  isHovered: boolean
  isClickable?: boolean
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const spacing = isOpen ? 25 : 5

  return (
    <SContainer
      onClick={() => {
        if (isClickable) {
          setIsOpen((open) => !open)
        }
      }}
    >
      {images.reverse().map((image, i) => (
        <SBackgroundSquare
          key={image}
          style={{
            top: isHovered ? (images.length - 1 - i) * spacing : 0,
            left: isHovered ? (images.length - 1 - i) * spacing : 0,
          }}
          src={image}
        />
      ))}
    </SContainer>
  )
}

export default withHoverable(ImageStack)
